import { AppAction, PageFilter } from '../../../../state/app';

export const FETCH_PENDING_APPROVAL_SAMPLE_DEV_HL_LIST =
  'FETCH_PENDING_APPROVAL_SAMPLE_DEV_HL_LIST';

export const fetchPendingApprovalSampleDevHlList = (paging: PageFilter): AppAction => {
  return {
    type: FETCH_PENDING_APPROVAL_SAMPLE_DEV_HL_LIST,
    payload: {
      filters: { 'HasResponded.EqualsTo': 'false' },
      paging,
    },
  };
};
